<template>
    <!-- Login dialog (form) -->
    <v-dialog
            v-if="!$user.onlineSluttKundeId || currentForm == state.FORCE_VERIFY"
            v-model="dialog"
            content-class="login-dialog"
            class="dialog-width"
            :max-width="$vuetify.breakpoint.mdAndUp ? '600' : ''"
            :fullscreen="$vuetify.breakpoint.smAndDown"
    >
        <template v-slot:activator="{ on }">
            <slot name="activator" v-bind:on="on"></slot>
        </template>

        <v-card class="login-dialog__content" :tile="$vuetify.breakpoint.xsOnly">
            <v-card-text :class="$vuetify.breakpoint.smAndUp ? 'pa-12' : 'py-12'">
                <v-btn icon @click="dialog = false" class="px-0" style="position: absolute; right: 1rem; top: 1rem;">
                    <v-icon>close</v-icon>
                </v-btn>

                <v-row>
                    <v-col cols="12" xs="12" sm="5" mb-12 :class="$vuetify.breakpoint.smAndUp ? 'pr-12' : ''">
                        <icon-title :src="$vuetify.breakpoint.xs ? '' : icon" :description="loginDescription">{{
                            getHeaderDescription }}
                        </icon-title>

                        <v-btn v-if="![state.LOGIN].includes(currentForm) && $vuetify.breakpoint.smAndUp"
                               style="align-self: flex-start" class="mt-auto" text @click="currentForm = state.LOGIN">
                            <v-icon left>arrow_back</v-icon>
                            Logg inn
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="7">
                        <transition mode="out-in"
                                    :name="[state.LOGIN].includes(currentForm) ? 'scroll-x-reverse-transition' : 'scroll-x-transition'">
                            <!-- Login form -->
                            <v-form key="login" v-if="[state.LOGIN].includes(currentForm)" v-model="formValidity"
                                    ref="form" @submit.prevent="logIn">
                                <v-text-field
                                        v-model="form.mobile"
                                        label="Mobilnummer*"
                                        class="prime mb-3"
                                        placeholder=" "
                                        type="tel"
                                        :rules="rules.mobile"
                                        required
                                        prefix="+47"
                                        v-mask="'########'"
                                        validate-on-blur
                                        :disabled="!!loading"
                                        autofocus
                                />
                                <v-text-field
                                        v-model="form.password"
                                        label="Passord*"
                                        class="prime"
                                        placeholder=" "
                                        :type="passwordVisible ? 'text' : 'password'"
                                        :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
                                        @click:append="passwordVisible = !passwordVisible"
                                        :rules="rules.password"
                                        required
                                        :disabled="!!loading"
                                />
                                <v-checkbox v-model="form.rememberMe" label="Husk meg" color="primary"
                                            class="mt-0 d-inline-flex" :disabled="!!loading"/>
                                <v-row class="mb-3">
                                    <v-col cols="12" xs="12" sm="6" class="pr-1">
                                        <v-btn color="primary" type="submit" depressed block
                                               :disabled="!formValidity || !!loading">Logg inn
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" class="pl-1">
                                        <v-btn depressed block :disabled="!!loading"
                                               @click="setMobileAndState(form.mobile, state.NEW)">Ny bruker
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <a @click="setMobileAndState(form.mobile, state.RECOVERY)">Glemt passord?</a>
                            </v-form>

                            <!-- Verification form -->
                            <div key="verification" v-else-if="[state.NEW, state.RECOVERY].includes(currentForm)">
                                <p class="mb-12">
                                    For å verifisere deg som bruker, trenger vi å sende deg en engangskode til ditt
                                    mobilnummer. Denne meldingen vil ikke påføre deg noen kostnad.
                                </p>
                                <transition mode="out-in"
                                            :name="true ? 'scroll-x-reverse-transition' : 'scroll-x-transition'">
                                    <v-form v-model="verificationFormMobileValidity"
                                            ref="verification-form-mobile-validity" key="mobile"
                                            v-if="!isVerificationCodeSent" @submit.prevent="sendVerificationCode">
                                        <v-text-field
                                                ref="verification-form-mobile"
                                                v-model="verificationForm.mobile"
                                                label="Mobilnummer*"
                                                class="prime mb-3"
                                                placeholder=" "
                                                type="tel"
                                                :rules="rules.mobile"
                                                required
                                                prefix="+47"
                                                v-mask="'########'"
                                                validate-on-blur
                                                :disabled="!!loading"
                                                autofocus
                                        />
                                        <v-btn depressed color="primary" type="submit"
                                               :disabled="!verificationFormMobileValidity">Send engangskode
                                        </v-btn>
                                        <v-btn v-if="![state.LOGIN].includes(currentForm) && $vuetify.breakpoint.xs"
                                               class="mt-4" style="float:right" text @click="currentForm = state.LOGIN">
                                            <v-icon left>arrow_back</v-icon>
                                            Logg inn
                                        </v-btn>
                                    </v-form>
                                    <v-form v-model="verificationFormVerificationCodeValidity"
                                            ref="verification-form-verification-code-validity" key="single-use-code"
                                            v-else @submit.prevent="verifyCode">
                                        <v-text-field
                                                v-model="verificationForm.verificationCode"
                                                ref="verification-form-verification-code"
                                                label="Engangskode*"
                                                class="prime mb-3"
                                                placeholder=" "
                                                :rules="rules.verificationCode"
                                                required
                                                :disabled="!!loading"
                                                autofocus
                                        />
                                        <v-btn depressed color="primary" type="submit"
                                               :disabled="!verificationFormVerificationCodeValidity">Verifiser
                                            engangskode
                                        </v-btn>
                                    </v-form>
                                </transition>
                            </div>
                            <!-- VERIFY PROFILE-->
                            <profile-registration-form
                                    key="verify"
                                    :overrideForm="overrideOptions"
                                    :user="registrationUser"
                                    :submitText="'Oppdater profil'"
                                    v-else-if="[state.VERIFY, state.FORCE_VERIFY].includes(currentForm)"
                                    @submit="createProfile"
                            />

                            <!-- Registration form -->
                            <profile-registration-form key="registration" :overrideForm="overrideOptions"
                                                       :user="registrationUser" v-else @submit="createProfile"/>
                        </transition>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-overlay absolute :value="!!loading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </v-dialog>

    <!-- Menu for logged in user  d -->
    <v-dialog v-else v-model="dialog" fullscreen transition="fade-transition" :attach="attach"
              content-class="user-menu">
        <template v-slot:activator="{ on }">
            <slot name="activator" v-bind:on="on"></slot>
        </template>

        <v-card class="primary user-menu__content d-flex align-center justify-end secondary--text" role="navigation"
                aria-label="User profile">
            <v-container fluid constrain--large d-flex text-right>
                <slot></slot>

                <a class="mt-12" @click="logOut">Logg ut</a>

                <v-overlay absolute :value="!!loading">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
   import ProfileRegistrationForm from './ProfileRegistrationForm';
   import IconTitle from './IconTitle';
   import {User} from '@/services/models';
   import {waitFor} from "vue-wait";

   export default {
      name: 'login-dialog',
      components: {ProfileRegistrationForm, IconTitle},
      props: {
         overrideOptions: {
            type: Object
         },
         value: Boolean,
         attach: String
      },
      data() {
         return {
            state: {
               NEW: 'new',
               RECOVERY: 'recovery',
               LOGIN: 'login',
               REGISTRATION: 'registration',
               VERIFY: 'verify',
               FORCE_VERIFY: 'force_verify'
            },
            currentForm: 'login', //this.state.LOGIN
            loginDescription: '',
            clientIdentity: null,
            form: {
               mobile: null,
               password: null,
               rememberMe: false
            },
            formValidity: false,
            loading: 0,
            icon: require('@/assets/img/app-icon.png'),
            passwordVisible: false,
            rules: {
               mobile: [v => !!v || 'Mobilnummer er påkrevd', v => (!!v && v.replace(/ /g, '').length == 8) || 'Mobilnummer krever 8 siffer'],
               password: [v => !!v || 'Passord er påkrevd'],
               verificationCode: [v => !!v || 'Engangskode er påkrevd']
            },
            verificationForm: {
               mobile: null,
               verificationCode: null
            },
            verificationFormMobileValidity: false,
            verificationFormVerificationCodeValidity: false,
            registrationUser: null,
            redirectUrl: null
         };
      },
      computed: {
         dialog: {
            get() {
               return this.value;
            },

            set(value) {
               this.$emit('input', value);
            }
         },

         isVerificationCodeSent() {
            return !!this.clientIdentity;
         },
         getHeaderDescription() {
            if ([this.state.LOGIN].includes(this.currentForm)) {
               return 'Innlogging';
            } else if ([this.state.RECOVERY].includes(this.currentForm)) {
               return 'Logg på med engangskode';
            } else if ([this.state.VERIFY].includes(this.currentForm)) {
               return 'Oppdater profil';
            } else if ([this.state.FORCE_VERIFY].includes(this.currentForm)) {
               return 'Oppdater profil';
            } else {
               return 'Registrer profil';
            }
         }
      },
      methods: {
         async createProfile(profile) {
            if (profile instanceof User) {
               this.loading++;
               const user = await this.$user.CreateProfile({
                  user: profile,
                  verificationCode: this.verificationForm.verificationCode,
                  clientIdentity: this.clientIdentity
               });
               if (user) {
                  setTimeout(() => {
                     this.$user.assign(user);
                     this.$forceUpdate();
                     this.$eventBus.$emit('user-logged-in', user);
                  }, 250); // Cooldown to let the dialog have time to close before updating.

                  this.dialog = false;
               }

               // Failed to create profile
               else {
                  this.$eventBus.$emit('snackbar', {
                     text: 'Oppretting av profil feilet. Vennligst se over om du har fylt inn riktig informasjon, og prøv på nytt.',
                     type: 'error'
                  });
               }
               this.loading--;
            }
         },

         async logIn() {
            if (this.formValidity) {
               this.loading++;
               waitFor(`loading user login`, async function () {
                  const user = await this.$user.LoginByPassword(this.form);
                  if (user) {
                     if (user.firstName.length == 0 || user.lastName.length == 0 || user.mobile.length == 0 || user.email.length == 0) {
                        this.registrationUser = user;
                        this.$eventBus.$emit('snackbar', {
                           text: 'Vi fant allerede en profil på dette mobilnummeret, vennligst verifiser personalia.',
                           type: 'success',
                           top: 'top'
                        });
                        this.currentForm = this.state.VERIFY;
                     } else {
                        let redirectUrlcopy;
                        if (this.redirectUrl) {
                           redirectUrlcopy = this.redirectUrl.slice(0); //copy string
                        }
                        this.$user.assign(user);
                        setTimeout(() => {
                           this.$forceUpdate();
                           this.$eventBus.$emit('user-logged-in', user);
                           if (redirectUrlcopy) {
                              this.$router.push(`${redirectUrlcopy}`);
                              redirectUrlcopy = '';
                           }
                        }, 250); // Cooldown to let the dialog have time to close before updating.
                        this.dialog = false;
                     }
                  }

                  // Login failed
                  else {
                     this.$eventBus.$emit('snackbar', {
                        text: 'Innlogging feilet. Sørg for at du har skrevet inn riktig mobilnummer/passord, og prøv på nytt.',
                        type: 'error'
                     });
                  }
                  this.loading--;
               }).apply(this)
            }
         },

         async logOut() {
            this.loading++;
            waitFor(`loading user logout`, async function () {
               if (await this.$user.Logout()) {
                  this.$user.assign(new User());
                  setTimeout(() => {
                     this.$forceUpdate();
                     this.$eventBus.$emit('user-logged-out');
                  }, 250);

                  this.dialog = false;

                  // To prevent error (NavigationDuplicated) "https://github.com/vuejs/vue-router/issues/2872"
                  // We use replace instead of push.
                  let chainId = this.$route.params.chainId || this.$route.query.chainId;
                  this.$router
                  .replace(chainId ? {name: 'webshopChain', params: {chainId}} : {name: 'frontpage'})
                  .catch(() => {
                  });
               }

               // Logout failed.
               else {
                  this.$eventBus.$emit('snackbar', {
                     text: 'Utlogging feilet. Vennligst prøv på nytt.',
                     type: 'error'
                  });
               }
            }).apply(this);
            this.loading--;
         },

         /**
          * Reset all forms
          */
         reset() {
            this.clientIdentity = null;
            this.passwordVisible = false;
            this.$refs['form'] && this.$refs['form'].reset();
            this.$refs['verification-form-mobile'] && this.$refs['verification-form-mobile'].reset();
            this.$refs['verification-form-verification-code'] && this.$refs['verification-form-verification-code'].reset();
            this.currentForm = this.state.LOGIN;
            this.loginDescription = '';
            this.redirectUrl = null;
         },

         async sendVerificationCode() {
            if (this.verificationFormMobileValidity) {
               this.loading++;

               const clientIdentity = await this.$user.SendVerificationCode({
                  mobile: this.verificationForm.mobile
               });
               if (clientIdentity) {
                  this.clientIdentity = clientIdentity;
               }

               // Failed to send verification code
               else {
                  this.$eventBus.$emit('snackbar', {
                     text: 'Klarte ikke å sende engangskode. Sørg for å skrive inn et gyldig mobilnummer, og prøv på nytt.',
                     type: 'error'
                  });
               }
               this.loading--;
            }
         },

         async verifyCode() {
            if (this.verificationFormVerificationCodeValidity) {
               this.loading++;
               if (
                  await this.$user.VerifyCode({
                     ...this.verificationForm,
                     clientIdentity: this.clientIdentity
                  })
               ) {
                  // Try to fetch profile for current mobile number
                  const profile = await this.$user.GetProfile({
                     ...this.verificationForm,
                     clientIdentity: this.clientIdentity
                  });

                  if (profile) {
                     // Profile exists. Log in user
                     if (profile.onlineSluttKundeId) {
                        const user = await this.$user.LoginByVerificationCode({
                           ...this.verificationForm,
                           clientIdentity: this.clientIdentity
                        });

                        if (user) {
                           // OnlineSluttkunde exists but missing required data
                           if (user.firstName.length == 0 || user.lastName.length == 0 || user.mobile.length == 0 || user.email.length == 0) {
                              this.registrationUser = await this.getProfileInfoForUser(this.verificationForm.mobile, this.verificationForm.verificationCode, this.clientIdentity);
                              this.$eventBus.$emit('snackbar', {
                                 text: 'Vi fant allerede en profil på dette mobilnummeret, vennligst verifiser personalia.',
                                 type: 'success',
                                 top: 'top'
                              });

                              this.currentForm = this.state.VERIFY;
                           } //if ([this.state.NEW].includes(this.currentForm)) {
                           else {
                              this.$eventBus.$emit('snackbar', {
                                 text: 'Det er allerede registrert en profil på dette mobilnummeret. Du blir nå logget inn.',
                                 type: 'success',
                                 top: 'top'
                              });
                              setTimeout(() => {
                                 this.$user.assign(user);
                                 this.$forceUpdate();
                                 this.$eventBus.$emit('user-logged-in', user);
                              }, 250);
                              this.dialog = false;
                           }
                        }
                     }

                     // Profile don't exist. Create a new profile
                     else {
                        if ([this.state.RECOVERY].includes(this.currentForm)) {
                           this.$eventBus.$emit('snackbar', {
                              text: 'Vi fant ingen brukerprofil på dette mobilnummeret. Fyll inn dine opplysninger for å registrere deg.',
                              top,
                              type: 'info'
                           });
                        }

                        this.registrationUser = await this.getProfileInfoForUser(this.verificationForm.mobile, this.verificationForm.verificationCode, this.clientIdentity);
                        this.currentForm = this.state.REGISTRATION;
                     }
                  }

                  // Failed to fetch profile
                  else {
                     this.$eventBus.$emit('snackbar', {
                        text: 'Klarer ikke å hente brukerprofil. Sørg for å skrive inn riktig mobilnummer og engangskode.',
                        type: 'error'
                     });
                  }
               }

               // Verification failed
               else {
                  this.$eventBus.$emit('snackbar', {
                     text: 'Verifisering feilet. Sørg for å skrive inn riktig mobilnummer og engangskode.',
                     type: 'error'
                  });
               }

               this.loading--;
            }
         },
         async getProfileInfoForUser(mobile, verificationCode, clientIdentity) {
            var customers = await this.$user.GetBestMatchCustomerByMobileAndChainId(mobile, verificationCode, clientIdentity, false, '');
            if (customers.length > 0) {
               return this.setPortalProfileFromCustomer(customers[0], mobile);
            } else {
               return new this.$user.constructor({
                  mobile: mobile
               });
            }
         },
         setPortalProfileFromCustomer(customer, mobile) {
            const cust = new this.$user.constructor({
               mobile: mobile,
               firstName: customer.FirstName,
               lastName: customer.LastName,
               email: customer.Email,
               sex: customer.Sex,
               address: customer.Address,
               postalCode: customer.PostalCode,
               postalArea: customer.PostalArea,
               birthDate: customer.BirthDate
            });
            return cust;
         },
         setMobileAndState(mobile, state) {
            this.verificationForm.mobile = mobile;
            this.currentForm = state;
         }
      },
      watch: {
         overrideOptions(options) {
            if (options) {
               this.currentForm = options.currentForm;
               this.loginDescription = options.loginDescription;
               this.redirectUrl = options.redirectUrl;
            }
         },
         currentForm(value) {
            // Reset forms when dialog's current form is set to 'login' again.
            if ([this.state.LOGIN].includes(value)) {
               this.reset();
            }
         },

         dialog(value) {
            // Reset forms when dialog is closed.
            if (!value) {
               this.reset();
            }
         },
         'verificationForm.mobile'(value) {
            if (value && value.replace(value.replace(/ /g, '').length == 8)) {
               if (this.$refs['verification-form-mobile']) {
                  this.$refs['verification-form-mobile'].validate();
               }
            }
         }
      }
   };
</script>

<style lang="scss">
    @import '~@/styles/variables';

    .login-dialog {
        margin-bottom: auto;
    }

    .user-menu {
        & > &__content {
            transition-property: background-color, color;

            & > .container {
                flex-direction: column;
            }

            a {
                color: currentColor;
                font-size: 3rem;
                font-weight: 700;
                max-height: 1.5em;
                text-decoration: none;

                &:hover {
                    color: var(--v-secondary-darken2);
                }

                @media #{map-get($display-breakpoints, 'md-and-down')} {
                    font-size: 2rem;
                }
            }
        }
    }
</style>
